import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // services/api.js আর লাগবে না
import "../styles/Register.css";

const isValidBDPhone = (phone) => {
  const patternWith88 = /^\+8801[3-9][0-9]{8}$/;
  const patternWithout88 = /^01[3-9][0-9]{8}$/;
  return patternWith88.test(phone) || patternWithout88.test(phone);
};

const Register = () => {
  const navigate = useNavigate();
  const [signupLocked, setSignupLocked] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    password: "",
    confirmPassword: "",
    referCode: "",
  });

  const [message, setMessage] = useState("");
  
  // ✅ Popup state
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({ phone: "", password: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: name === "referCode" ? value.toUpperCase().trim() : value,
    });
  };

  useEffect(() => {
    axios
      .get("https://api.earnmoney0.top/admin/signup-lock")
      .then((res) => setSignupLocked(res.data.signupLock))
      .catch((err) => console.error("Signup Lock fetch error:", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (signupLocked) {
      setMessage("🔒 নতুন একাউন্ট খোলা বন্ধ আছে। পরে আবার চেষ্টা করুন");
      return;
    }

    if (!isValidBDPhone(form.phone)) {
      setMessage("🚫 ভুল নাম্বার, সঠিক ফোন নাম্বার দিন)");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setMessage("❌ পাসওয়ার্ড মিলছে না");
      return;
    }

    try {
      const payload = {
        name: form.name,
        phone: form.phone,
        password: form.password,
      };

      if (form.referCode) payload.referCode = form.referCode.trim().toUpperCase();

      const res = await axios.post("https://api.earnmoney0.top/api/auth/register", payload);

      setMessage(res.data.message || "✅ সফলভাবে রেজিস্ট্রেশন হয়েছে");

      // ✅ Show popup
      setPopupData({ phone: form.phone, password: form.password });
      setShowPopup(true);

      // Reset form
      setForm({
        name: "",
        phone: "",
        password: "",
        confirmPassword: "",
        referCode: "",
      });

      // 5 সেকেন্ড পরে অটো-login page
      setTimeout(() => navigate("/login"), 5000);

    } catch (err) {
      console.error(err.response?.data);
      setMessage(err.response?.data?.message || "❌ কিছু ভুল হয়েছে");
    }
  };

  return (
    <div className="register-wrapper">
      {/* LEFT SIDE */}
      <div className="register-left">
        <h1 className="title">রেজিস্ট্রেশন ফর্ম</h1>
        <div className="marquee">
          <span>
            আসসালামু আলাইকুম, একাউন্ট রেজিস্ট্রেশন করলেই পাচ্ছেন ২৫ টাকা ইনস্ট্যান্ট
            কমিশন বোনাস 🎉 আরো থাকছে বিভিন্ন রেওয়ার্ড এর সুযোগ ✨ এবং আপনার
            রেফার কোড ব্যবহার করে ইউজার একাউন্ড রেজিষ্ট্রেশন করলে আপনি পাচ্ছেন ১০
            টাকা কমিশন 🎁🎊 তাই এখনি একাউন্ট রেজিস্ট্রেশন করে আপনার বন্ধদের
            আমন্ত্রণ করুন আপনার রেফার কোড দিয়ে রেজিষ্ট্রেশন করার জন্য 🎋🎆
          </span>
        </div>
        <p className="info-text">
          এখনই একাউন্ট খুলে আমাদের সকল প্রিমিয়াম সার্ভিস উপভোগ করুন 🚀
        </p>
      </div>

      {/* RIGHT SIDE */}
      <div className="register-right">
        <form className="register-form" onSubmit={handleSubmit}>
          {message && <p className="message">{message}</p>}

          <div className="form-group">
            <label>নাম</label>
            <input
              type="text"
              name="name"
              placeholder="আপনার নাম লিখুন"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>ফোন নাম্বার</label>
            <input
              type="text"
              name="phone"
              placeholder="আপনার ফোন নাম্বার লিখুন"
              value={form.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>পাসওয়ার্ড</label>
            <input
              type="password"
              name="password"
              placeholder="পাসওয়ার্ড লিখুন"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>কনফার্ম পাসওয়ার্ড</label>
            <input
              type="password"
              name="confirmPassword"
              placeholder="পুনরায় পাসওয়ার্ড লিখুন"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>রেফারেন্স কোড</label>
            <input
              type="text"
              name="referCode"
              placeholder="যদি থাকে বসান, না থাকলে খালি রাখুন"
              value={form.referCode}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="submit-btn" disabled={signupLocked}>
            {signupLocked ? "নতুন একাউন্ট খোলা বন্ধ 🔒" : "রেজিস্ট্রেশন করুন ✅"}
          </button>

          <p className="back-login">
            <a href="/login">লগইন পেজ 🔙</a>
          </p>
        </form>
      </div>

      {/* ✅ Popup */}
      {showPopup && (
        <div className="popup-backdrop">
          <div className="popup-content">
            <h2>🎉আপনার লগইন ডিটেইলস🎉</h2>
            <p>ফোন নাম্বার: {popupData.phone}</p>
            <p>পাসওয়ার্ড: {popupData.password}</p>
            <p>একাউন্ট এর ডিটেইলস সংগ্রহ করে রাখুন পরবর্তীতে লগইন করতে সুবিধা হবে ✅</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;